import {useSearchParams} from 'react-router'

import {ViewMode} from '../types'

function urlParamsToViewMode(params: URLSearchParams): ViewMode {
  const eventId = params.get('eventId') ?? undefined
  const mode = params.get('mode') ?? undefined

  switch (mode) {
    case undefined:
      return eventId ? {mode: 'detailsMode', itemId: eventId} : {mode: 'tableOnlyMode'}
    case 'editMode':
    case 'detailsMode':
      if (!eventId) throw new Error('Event Id must be given with mode')
      return {mode, itemId: eventId}
    case 'createMode':
      return {mode: 'createMode'}
    default:
      throw new Error('Unknown mode given in URL')
  }
}

export function viewModeToUrlParams(viewMode: ViewMode): URLSearchParams {
  const params = new URLSearchParams()

  switch (viewMode.mode) {
    case 'tableOnlyMode':
      return params
    case 'editMode':
    case 'detailsMode':
      params.append('mode', viewMode.mode)
      params.append('eventId', viewMode.itemId.toString())
      return params
    case 'createMode':
      params.append('mode', 'createMode')
      return params
    default:
      return params
  }
}

export const useQueryParameterForViewMode = (): ViewMode => {
  const [params] = useSearchParams()
  return urlParamsToViewMode(params)
}
